import { render, staticRenderFns } from "./ShipmentReceivedForm.vue?vue&type=template&id=5bf00980&scoped=true&"
import script from "./ShipmentReceivedForm.vue?vue&type=script&lang=js&"
export * from "./ShipmentReceivedForm.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentReceivedForm.vue?vue&type=style&index=0&id=5bf00980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf00980",
  null
  
)

export default component.exports